import preset from '@/@core/preset/preset'
import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import tr from 'vuetify/lib/locale/tr'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { tr },
    current: 'tr',
  },
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
